import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import apiConfig from "../../utilities/apiConfig.json";
import serverConfig from "../../utilities/serverConfig.json";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./../../Styles/pages/components.scss";
import PlaceImgNotFound from "./../../assets/images/place-not-found.svg";
import {
  FormControl,
  FormHelperText,
  InputAdornment,
  OutlinedInput,
} from "@mui/material";
import constData from "../../utilities/const.json";
import DoctorCard from "../doctor/doctorCard";
import DepartmentCard from "../department/departmentCard";
import ShowMoreLessButton from "../../components/ShowMoreLessText/ShowMoreLessButton";
import { ReactComponent as ChevronDownIcon } from "./../../assets/images/icons/Google SVGs/chevron_down.svg";
import SearchIcon from "./../../assets/images/icons/Google SVGs/search.svg";
import { ReactComponent as ArrowRightAltIcon } from "./../../assets/images/icons/Google SVGs/arrow_right_alt.svg";
import isWhitespaceString from "../../utilities/functions/isWhiteSpaceString";
import ShareLinkModal from "../../components/modals/share/shareModal";
import haveAccess from "../../utilities/functions/haveAccess";
import { useDispatch, useSelector } from "react-redux";
import FloatTitleCard from "../../components/cards/floatTitleCard";
import scrollToTop from "../../utilities/functions/ScrollToTop";

const PlaceProfile = (props) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { roles } = useSelector((state) => state.user);

  // #region auth parameter
  const headers = {
    Authorization: "Bearer " + localStorage.getItem("token"),
  };
  // #endregion
  const [loading, setLoading] = useState(false);

  const [showLoginModal, setShowLoginModal] = useState(false);
  const isMobile = window.innerWidth >= 992 ? false : true;

  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  // Extracting query parameters from the URL
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const pl = queryParams.get("pl"); // Getting the value of 'pl' from the query string
  const dep = queryParams.get("dep"); // Getting the value of 'dep' from the query string

  const [doctors, setDoctors] = useState();

  // #region pages variables
  const [searchValue, setSearchValue] = useState("");
  const [paginationElem, setPaginationElem] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(15);
  const maxVisiblePages = 5; // Adjust this value as needed
  //  #endregion

  const [placeDoctorId, setPlaceDoctorId] = useState();
  const [placeTitle, setPlaceTitle] = useState();
  const [placeFiles, setPlaceFiles] = useState();
  const [placeTechnicalPhone, setTechnicalPhone] = useState();
  const [showPhone, setShowPhone] = useState(false);

  const [placeType, setPlaceType] = useState();
  const [placeDescription, setPlaceDescription] = useState();
  const [placeAddress, setPlaceAddress] = useState();

  // data for choose parent dep
  const [departments, setDepartments] = useState([]);
  const [subDepartments, setSubDepartments] = useState([])
  const [expandedDepartment, setExpandedDepartment] = useState(null)
  const [department, setDepartment] = useState({ id: null, title: null });
  const [departmentSearch, setDepartmentSearch] = useState("");

  const getPlaceDetail = () => {
    axios
      .get(
        serverConfig.server.url + apiConfig.api.getAPIs.getPlaces + "/" + pl,
        headers
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          setPlaceTitle(response.data.data.place.title);
          response.data.data.files
            ? setPlaceFiles(response.data.data.files)
            : setPlaceFiles();
          setTechnicalPhone(response.data.data.place.technical_phone);
          setPlaceType(response.data.data.place.type);
          setPlaceDescription(response.data.data.place.biography);
          setPlaceAddress(response.data.data.place.address);
          if (
            !(departments.length > 0) &&
            response.data.data?.departments_list?.length
          ) {

            const parrentDepartments = []
            const subDepartments = []

            response.data.data.departments_list.forEach(dep => {
              if (dep.parent_id) {
                subDepartments.push(dep)
              }
              else {
                parrentDepartments.push(dep)
              }
            })

            console.log(response.data.data.departments_list)
            setDepartments(parrentDepartments);
            setSubDepartments(subDepartments)

          }
          /*
           .city_id
           .files (array)
           .technical_phone (or support_phone?)
           .type (type of HC)
           .description (or biography?)
           .address
          */
        } else {
          if (response.data.code == 404) {
            navigate("/404");
          } else if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const getPlaceDepartmentsDoctors = () => {
    setLoading(true);
    axios
      .post(
        serverConfig.server.url +
        apiConfig.api.getAPIs.getDoctorsForDepartmentPlace +
        parseInt(pl) +
        "/doctors" +
        "?page=" +
        currentPage,
        department.id != null
          ? {
            department_id: department.id,
            per_page: perPage,
            ...(isWhitespaceString(searchValue) && {
              search_value: searchValue,
            }),
            pagination: true,
          }
          : {
            per_page: perPage,
            search_value: searchValue,
            pagination: true,
          },
        {
          headers,
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          setDoctors(response.data.data.doctors_list);

          // pagination
          const paginationItems = [];
          const totalPages = response.data.data.page_count;
          if (totalPages > 1) {
            // Calculate the range of pages to display
            const startPage = Math.max(
              1,
              currentPage - Math.floor(maxVisiblePages / 2)
            );
            let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

            // Add previous button if not on the first page
            if (currentPage !== 1) {
              paginationItems.push(
                <li key="prev" className="page-item">
                  <a
                    className="page-link"
                    href="#"
                    onClick={() => {
                      setCurrentPage(currentPage - 1);
                      scrollToTop();
                    }}
                  >
                    <span aria-hidden="true">&laquo;</span>
                  </a>
                </li>
              );
            }
            // Add first button if not on the first page
            if (currentPage !== 1 && currentPage !== 2) {
              paginationItems.push(
                <li key="first" className="page-item">
                  <a
                    className="page-link"
                    href="#"
                    onClick={() => {
                      setCurrentPage(1);
                      scrollToTop();
                    }}
                  >
                    1
                  </a>
                </li>
              );
            }

            // Add ellipsis before first page if necessary
            if (startPage > 1) {
              paginationItems.push(
                <li key="ellipsis1" className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
              );
            }

            // Add page numbers
            for (let i = startPage; i < endPage; i++) {
              paginationItems.push(
                <li
                  key={i}
                  className={"page-item" + (currentPage === i ? " active" : "")}
                >
                  <a
                    className="page-link"
                    href="#"
                    onClick={() => {
                      setCurrentPage(i);
                      scrollToTop();
                    }}
                  >
                    {i}
                  </a>
                </li>
              );
            }

            // Add ellipsis after last page if necessary
            if (endPage < totalPages) {
              paginationItems.push(
                <li key="ellipsis2" className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
              );
            }

            // Add last button if not on the last page
            if (currentPage !== totalPages && currentPage !== totalPages - 1) {
              paginationItems.push(
                <li key="last" className="page-item">
                  <a
                    className="page-link"
                    href="#"
                    onClick={() => {
                      setCurrentPage(totalPages);
                      scrollToTop();
                    }}
                  >
                    {totalPages}
                  </a>
                </li>
              );
            }

            // Add next button if not on the last page
            if (currentPage !== totalPages) {
              paginationItems.push(
                <li key="next" className="page-item">
                  <a
                    className="page-link"
                    href="#"
                    onClick={() => {
                      setCurrentPage(currentPage + 1);
                    }}
                  >
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              );
            }

            setPaginationElem(paginationItems);
          }
          // end pagination
        } else {
          if (response.data.code == 404) {
            navigate("/404");
          } else if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const changeDepartment = (department) => {
    if (department.length == 0) {
      setDepartment({ id: null, title: null });
    } else {
      setDepartment({ id: department.id, title: department.title });
    }
  };

  const handleDepartmentSelect = (depData) => {

    const selectedDepSubDeps = [...subDepartments].filter(subDep => subDep.parent_id === depData.id)

    if (depData.parent_id) return changeDepartment(depData)
    if (!selectedDepSubDeps?.length) return changeDepartment(depData)

    setExpandedDepartment(prev => prev ? null : selectedDepSubDeps)

  }

  useEffect(() => {
    getPlaceDetail();
  }, []);

  useEffect(() => {
    getPlaceDepartmentsDoctors();
  }, []);

  useEffect(() => {
    if (department) {
      getPlaceDepartmentsDoctors();
    }
  }, [department, searchValue]);

  useEffect(() => {
    if (dep) {
      departments.filter((department) => {
        if (department.id == dep) {
          setDepartment({ id: department.id, title: department.title });
        }
      });
    }
  }, [departments]);

  // pagination
  useEffect(() => {
    getPlaceDepartmentsDoctors();
  }, [currentPage]);

  useEffect(() => {
    setCurrentPage(1);
    getPlaceDepartmentsDoctors();
  }, [searchValue, perPage]);
  // [searchValue, perPage]
  // pagination

  return (
    <div className="pt-lg-3 row">

      <div className="col-lg-6">
        <FloatTitleCard title={"مشخصات مرکز درمانی"}>
          <div className="d-flex row pt-0">
            <div className="d-flex justify-content-center position-relative">
              <img
                className="place-image-box"
                src={
                  placeFiles && placeFiles.length != 0
                    ? placeFiles
                    : PlaceImgNotFound
                }
              />
              <div
                className="position-absolute"
                style={{
                  left: isMobile ? "28px" : "24px",
                  top: isMobile ? "16px" : "16px",
                }}
              >
                <ShareLinkModal
                  justIcon={true}
                  text={placeTitle}
                  link={window.location.href}
                  name={placeTitle}
                />
              </div>
              {(haveAccess(roles, "place_add") ||
                haveAccess(roles, "place_edit")) && (
                  <div
                    className="position-absolute d-flex fs-10 btn btn-light color-bootstrap-gray-700 rounded-3 h-fit p-2"
                    style={{
                      left: isMobile ? "78px" : "74px",
                      top: isMobile ? "16px" : "16px",
                    }}
                    onClick={() => navigate(`/place-store?pl=${pl}&action=edit`)}
                  >
                    ویرایش مرکز درمانی
                  </div>
                )}
            </div>
            <span className="fs-18 color-bootstrap-gray-700 fw-bold mt-2 text-center">
              {placeTitle}
            </span>
            {/* <div className="row mt-4">
              <div className="col d-flex flex-column fs-14">
                <div className="d-flex border-right flex-column ps-2">
                  <span className="fw-normal color-bootstrap-gray-600">
                    تلفن تماس
                  </span>
                  {placeTechnicalPhone ? (
                    <a
                      className="text-decoration-none color-bootstrap-gray-600"
                      href={`tel:${placeTechnicalPhone}`}
                    >
                      {placeTechnicalPhone}
                    </a>
                  ) : (
                    "تلفنی ثبت نشده است"
                  )}
                </div>
              </div>
              <div className="col d-flex flex-column fs-14">
                <div className="d-flex border-right flex-column ps-2">
                  <span className="fw-normal color-bootstrap-gray-600">
                    نوع مرکز درمانی
                  </span>
                  <span>
                    {constData.placeTypes.find((e) => e.id == placeType)?.name}
                  </span>
                </div>
              </div>
            </div> */}
            {placeDescription ? (
              <p className="fs-14 rtl-p pt-4 m-0 color-bootstrap-gray-600">
                {/* <strong className="fs-14 fw-medium color-bootstrap-gray-700">
                  ‌توضیحات :&nbsp;
                </strong> */}
                {/* <div
              dangerouslySetInnerHTML={{
                __html:
                  placeDescription &&
                  placeDescription.replace(/\r\n/g, "<br />"),
              }}
            /> */}
                {placeDescription &&
                  (placeDescription.split(' ').length > 118 ? (
                    <ShowMoreLessButton
                      init={
                        <strong className="fs-14 fw-medium color-bootstrap-gray-700">
                          ‌توضیحات :&nbsp;
                        </strong>
                      }
                      content={placeDescription}
                      maxHeight={"158px"}
                    />
                  ) : (
                    placeDescription
                  ))}
              </p>
            ) : (
              <></>
              // <p className="fs-14 rtl-p pt-4 m-0 color-bootstrap-gray-600">
              //   <strong className="fs-14 fw-medium color-bootstrap-gray-700">
              //     ‌توضیحات :&nbsp;
              //   </strong>
              //   بدون توضیحات
              // </p>
            )}
            <p className="fs-14 rtl-p pt-4 m-0 color-bootstrap-gray-600">
              <strong className="fs-14 fw-medium color-bootstrap-gray-700">
                آدرس :&nbsp;
              </strong>
              {placeAddress}
            </p>
            {placeTechnicalPhone ? (

              <div>
                <a
                  className="d-flex flex-row rounded-3 text-decoration-none background-bootstrap-gray-100 color-bootstrap-gray-700 py-2 px-12px mt-4 w-100"
                  href={`tel:${placeTechnicalPhone}`}
                  onClick={() => setShowPhone(false)} // Set showPhone to false to show masked version after clicking
                >
                  <span>شماره تماس</span>
                  <div className="d-flex w-fit color-bootstrap-gray-700 ms-auto">
                    {placeTechnicalPhone}
                  </div>
                </a>
              </div>

            ) : (
              <div className="d-flex flex-row rounded-3 background-bootstrap-gray-100 color-bootstrap-gray-700 py-2 px-12px mt-4 w-100">
                <span>تلفنی ثبت نشده است</span>
              </div>
            )}

          </div>
        </FloatTitleCard>
      </div>
      <div className="col-lg-6">
        <FloatTitleCard title={"لیست پزشکان"}>
          <div className="d-flex row pt-3">
            <div className="d-flex flex-column align-items-center mb-3">
              <div className="col-12 mb-3">
                <div
                  className="card background-bootstrap-gray-100 border-gray-400 h-48"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#department-modal"
                >
                  <div className="card-body d-flex flex-row py-2">
                    <div className="d-flex align-items-center">
                      {!department.id && (
                        <span className="card-title my-0 fs-14 fw-normal color-bootstrap-gray-600">
                          انتخاب دپارتمان
                        </span>
                      )}
                      {department.id && (
                        <span className="card-title my-0 fs-14 fw-bold color-bootstrap-gray-600">
                          {department.title}
                        </span>
                      )}
                      {!department.id && loading && (
                        <span
                          className="spinner-border spinner-border-sm ms-1"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                    </div>
                    <div className="ms-auto d-flex align-items-center">
                      <ChevronDownIcon width={24} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 mb-3">
                <FormControl
                  sx={{ marginY: 1, width: "100%" }}
                  variant="outlined"
                  className="m-0"
                >
                  <OutlinedInput
                    className="border-0 rounded background-bootstrap-gray-100 h-48 border-gray-400"
                    classes={{
                      input: "p-2 fs-14 placeholder-gray-600",
                    }}
                    id="outlined-adornment-weight"
                    value={searchValue}
                    placeholder="جستجوی نام پزشک"
                    onChange={(e) => {
                      setSearchValue(e.target.value);
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <img src={SearchIcon} alt="" />
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </div>
            </div>
            {/* <hr className="w-100"/> */}
            {loading && (
              <span
                className="spinner-border spinner-border ms-1"
                role="status"
                aria-hidden="true"
              />
            )}
            {!loading &&
              doctors &&
              doctors.map((doctor, index) => (
                <div className="col col-12 mx-0 mb-3" key={index}>
                  {/* <a
                className="text-decoration-none"
                href={`/doctor?${
                  "dr=" +
                  doctor.id +
                  `${department.id ? "&dep=" + department.id : ""}` +
                  "&" +
                  "pl=" +
                  pl
                }`}
              > */}
                  <DoctorCard
                    doctor={doctor}
                    place={pl}
                    department={department.id}
                  />
                  {/* </a> */}
                </div>
              ))}
            {!loading && paginationElem && (
              <nav aria-label="Page navigation example">
                <ul className="pagination">{paginationElem}</ul>
              </nav>
            )}
          </div>
        </FloatTitleCard>
      </div>

      {/* select department modal */}
      <div
        className="modal fade"
        id="department-modal"
        tabIndex="-1"
        aria-labelledby="department-modal-label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">

            <div className="modal-header border-bottom mx-0 py-2">
              <ArrowRightAltIcon
                className="color-bootstrap-gray-800"
                width={24}
                height={24}
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <input
                type="text"
                className="form-control border-0 shadow-none w-100 color-iso-gray"
                id="department-search-input"
                placeholder="انتخاب دپارتمان ..."
                value={departmentSearch}
                onChange={(e) => setDepartmentSearch(e.target.value)}
              />
            </div>

            <div className="modal-body">
              <button
                className="btn btn-light w-100 d-flex align-items-start my-2"
                data-bs-dismiss="modal"
                onClick={() => changeDepartment({ id: null, title: null })}
              >
                همه دپارتمان ها
              </button>
              <div className="d-flex flex-column align-items-start">
                {departments &&
                  departments
                    .filter((department) => department.title.includes(departmentSearch.trim()))
                    .map((department, index) => (
                      <div key={index} className="tw-w-full">
                        <div
                          key={index}
                          className="w-100 d-flex col-12 my-2 btn p-0 border-0"
                          onClick={() => handleDepartmentSelect(department)}
                          data-bs-dismiss={!subDepartments?.find(dep => dep?.parent_id === department?.id) ? 'modal' : null}
                          aria-label="Close"
                        >
                          <DepartmentCard
                            key={department.id}
                            departmentId={department.id}
                            departmentTitle={department.title}
                            is_sub={!subDepartments?.find(dep => dep?.parent_id === department?.id)}
                            files={department.file}
                            edit={false}
                          />
                        </div>

                        <div className="tw-space-y-2 tw-w-3/4">
                          {
                            expandedDepartment?.length && expandedDepartment.filter(dep => dep.parent_id === department.id).map(sub =>
                              <div
                                key={sub.id}
                                onClick={() => changeDepartment(sub)}
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              >
                                <DepartmentCard
                                  key={sub.id}
                                  departmentId={sub.id}
                                  departmentTitle={sub.title}
                                  is_sub={true}
                                  files={sub.file}
                                  edit={false}
                                />
                              </div>
                            )
                          }
                        </div>

                      </div>

                      // <button
                      //   className="btn btn-light w-100 d-flex align-items-start my-2"
                      //   data-bs-dismiss="modal"
                      //   key={department.id}
                      //   onClick={() => changeDepartment(department)}
                      // >
                      //   {department.title}
                      // </button>
                    ))}
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  );
};

export default PlaceProfile;
